<template>
  <Modal v-model="networkModal" :close="() => { close() }">
    <div class="lcu-modal">
      <div class="row">
        <p class="lcu-center-text">
        You internet seems to be broken.
        </p>
      </div>
      <div>
        <button-cta
        :text="'Ok'"
        :classes="['full-width-btn']"
        @on-click="close" />
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapGetters } from 'vuex';
import ButtonCta from 'ç/buttons/Cta.vue';

export default {
  name: 'network-modal',
  components: {
    ButtonCta,
  },
  computed: {
    ...mapGetters(['networkModal']),
  },
  methods: {
    close() {
      this.$store.dispatch('setNetworkModal', false);
    },
  },
};
</script>

<style scoped lang="scss">
.full-width-btn {
  width: 100%;
}
</style>
